import React, { FC } from 'react';
import IndicatorLoader from 'components/Loaders/Indicator';
import Select from 'components/Form/Select';
import {
  Container,
  Indicators,
  Indicator,
  // DatesSelector,
  Header,
  // DateCaption,
} from './styles';
import useConnect from './connect';
import { Props, Content, BrandItem } from './types';

const Operations: FC<Props> = ({ brandId }) => {
  const {
    operations,
    isLoading,
    // hoverRange,
    // selectedDays,
    // handleDayChange,
    // handleDayEnter,
    // handleDayLeave,
    // handleWeekClick,
    integration,
    setIntegration,
  } = useConnect({
    brandId,
  });
  const pageContent: Content = {
    ubereats_manager: [
      {
        title: 'Order Count',
        key: 'order_count',
      },
      {
        title: 'AOV',
        key: 'aov',
      },
      {
        title: 'Sales',
        key: 'sales',
      },
      {
        title: 'Missed Orders',
        key: 'missed_orders',
      },
      {
        title: 'Inaccurate Orders',
        key: 'inaccurate_orders',
      },
      {
        title: 'Downtime',
        key: 'downtime',
      },
      {
        title: 'Cancelled Orders',
        key: 'cancelled_orders',
      },
      {
        title: 'New Customers',
        key: 'new_customers',
      },
      {
        title: 'Repeat Customers',
        key: 'repeat_customers',
      },
    ],
    doordash: [
      {
        title: 'Order Count',
        key: 'order_count',
      },
      {
        title: 'AOV',
        key: 'aov',
      },
      {
        title: 'Sales',
        key: 'sales',
      },
      {
        title: 'Missed Orders',
        key: 'missed_orders',
      },
      {
        title: 'Inaccurate Orders',
        key: 'inaccurate_orders',
      },
      {
        title: 'Downtime',
        key: 'downtime',
      },
      {
        title: 'Cancelled Orders',
        key: 'cancelled_orders',
      },
      {
        title: 'New Customers',
        key: 'new_customers',
      },
      {
        title: 'Repeat Customers',
        key: 'repeat_customers',
      },
    ],
    grubhub: [
      {
        title: 'Order Count',
        key: 'order_count',
      },
      {
        title: 'AOV',
        key: 'aov',
      },
      {
        title: 'Sales',
        key: 'sales',
      },
      {
        title: 'Avg Confirmation Time',
        key: 'avg_confirmation_time',
      },
      {
        title: 'Food Rating',
        key: 'food_rating',
      },
      {
        title: 'Delivery Rating',
        key: 'delivery_rating',
      },
      {
        title: 'Accuracy Rating',
        key: 'accuracy_rating',
      },
    ],
  };

  return (
    <Container>
      <Header>
        {/* <DateCaption>Date range</DateCaption>
        <DatesSelector
          hoverRange={hoverRange}
          selectedDays={selectedDays}
          handleDayChange={handleDayChange}
          handleDayEnter={handleDayEnter}
          handleDayLeave={handleDayLeave}
          handleWeekClick={handleWeekClick}
        /> */}
        <Select
          style={{ marginLeft: '1rem' }}
          value={integration}
          onChange={(label: any) => {
            setIntegration(label.target.value);
          }}
          options={[
            {
              label: 'Uber',
              value: 'ubereats_manager',
              disabled: false,
            },
            {
              label: 'Doordash',
              value: 'doordash',
              disabled: false,
            },
            {
              label: 'Grubhub',
              value: 'grubhub',
              disabled: false,
            },
          ]}
        />
      </Header>

      <Indicators>
        {!operations || isLoading ? (
          <>
            {pageContent[integration].map(() => (
              <IndicatorLoader />
            ))}
          </>
        ) : (
          <>
            {pageContent[integration].map((item: BrandItem) => {
              const { value = 0, change = 0 } = operations[item.key] || {};
              const trend = change >= 0 ? 'UP' : 'DOWN';
              return (
                <Indicator
                  title={item.title}
                  amount={`${value}`}
                  trend={trend}
                  percentage={change}
                />
              );
            })}
          </>
        )}
      </Indicators>
    </Container>
  );
};

export default Operations;
